<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
    name: 'App',
    components: {
    }
}
</script>


<style>
html, body {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  position:relative;
  font-family: "Lucida Console", Courier, monospace;
  /* font-family: "Helvetica Neue, Hiragino Sans GB"; */
  /* font-family: Helvetica, 'Hiragino Sans GB', 'Microsoft Yahei', '微软雅黑', Arial, sans-serif; */
  /* font: 12px/1 Tahoma,Helvetica,Arial,"\5b8b\4f53",sans-serif; */
}

#app {
  position: absolute;
  height: 100%;
  width: 100%;
}
</style>
